import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
export default {
  name: 'Youzi',
  data() {
    return {
      loading: false,
      errorMsg: '',
      refreshing: false,
      cycleLoaded: false,
      topTipOpen: false,
      mtFloat: {
        show: false,
        x: 0,
        y: 0,
        text: ''
      },
      lastUpdateTime: '',
      countdown: 15,
      rawCycle: [],
      cycleData: [],
      priceMap: {},
      limitUpStocks: [],
      limitDownStocks: [],
      brokenStocks: [],
      yesterdayLimitUpStocks: [],
      poolsLoaded: false,
      // 定时器
      snapshotTimer: null,
      poolTimer: null,
      cycleTimer: null,
      countdownTimer: null
    };
  },
  computed: {
    latestDay() {
      return this.rawCycle.length ? this.rawCycle[this.rawCycle.length - 1] : null;
    },
    prevDay() {
      return this.rawCycle.length > 1 ? this.rawCycle[this.rawCycle.length - 2] : null;
    },
    // 昨日数据（用于计算今日晋级率的基准，排除今日部分数据）
    yesterdayDay() {
      const todayStr = this.formatDate(new Date());
      for (let i = this.rawCycle.length - 1; i >= 0; i--) {
        if (this.rawCycle[i].date !== todayStr && this.rawCycle[i].ladder) return this.rawCycle[i];
      }
      return null;
    },
    // 实时情绪指标：从涨停池+炸板池+跌停池计算，晋级率基于昨日天梯
    realtimeEmotionMetrics() {
      if (!this.limitUpStocks.length && !this.brokenStocks.length) return null;
      const yd = this.yesterdayDay;
      const pr = {};
      if (yd && yd.ladder) {
        const yCounts = {};
        Object.keys(yd.ladder).forEach(level => {
          yCounts[level] = (yd.ladder[level] || []).length;
        });
        const tCounts = {};
        this.limitUpStocks.forEach(s => {
          const d = s.limit_up_days || 1;
          tCounts[d] = (tCounts[d] || 0) + 1;
        });
        const y1 = yCounts['1'] || 0;
        const y2 = yCounts['2'] || 0;
        const yHigh = Object.keys(yCounts).filter(k => parseInt(k) >= 2).reduce((s, k) => s + yCounts[k], 0);
        if (y1 > 0) pr['1to2'] = +((tCounts[2] || 0) / y1 * 100).toFixed(1);
        if (y2 > 0) pr['2to3'] = +((tCounts[3] || 0) / y2 * 100).toFixed(1);
        if ((yCounts['3'] || 0) > 0) pr['3to4'] = +((tCounts[4] || 0) / yCounts['3'] * 100).toFixed(1);
        if (yHigh > 0) pr.high = +(Object.keys(tCounts).filter(k => parseInt(k) >= 3).reduce((s, k) => s + tCounts[k], 0) / yHigh * 100).toFixed(1);
      }
      const total = this.limitUpStocks.length + this.brokenStocks.length;
      return {
        promotionRates: pr,
        brokenRatio: total ? this.brokenStocks.length / total : 0,
        brokenCount: this.brokenStocks.length,
        limitDownCount: this.limitDownStocks.length
      };
    },
    // 情绪指标统一入口：优先实时，回退周期
    latestEmotionMetrics() {
      return this.realtimeEmotionMetrics || this.latestDay && this.latestDay.emotionMetrics || null;
    },
    latestDate() {
      return this.latestDay ? this.latestDay.date : '—';
    },
    emotionMetrics() {
      const e = this.latestEmotionMetrics;
      if (!e) return [];
      const pr = e.promotionRates || {};
      const avg5 = this.avgMetrics(5);
      const brokenPct = e.brokenRatio != null ? +(e.brokenRatio * 100).toFixed(1) : 0;
      return [{
        key: 'highPromo',
        label: '高位晋级',
        value: pr.high != null ? pr.high : 0,
        unit: '%',
        cls: pr.high >= 50 ? 'c-up' : pr.high >= 30 ? 'c-neutral' : 'c-down',
        diff: avg5.highPromo != null && pr.high != null ? +(pr.high - avg5.highPromo).toFixed(1) : null
      }, {
        key: 'p12',
        label: '1进2',
        value: pr['1to2'] != null ? pr['1to2'] : 0,
        unit: '%',
        cls: pr['1to2'] >= 50 ? 'c-up' : pr['1to2'] >= 30 ? 'c-neutral' : 'c-down',
        diff: avg5.p12 != null && pr['1to2'] != null ? +(pr['1to2'] - avg5.p12).toFixed(1) : null
      }, {
        key: 'broken',
        label: '炸板率',
        value: brokenPct,
        unit: '%',
        cls: e.brokenRatio <= 0.2 ? 'c-up' : e.brokenRatio <= 0.4 ? 'c-neutral' : 'c-down',
        diff: avg5.brokenRatio != null ? +(brokenPct - avg5.brokenRatio).toFixed(1) : null
      }, {
        key: 'limitDown',
        label: '跌停数',
        value: e.limitDownCount || 0,
        unit: '',
        cls: (e.limitDownCount || 0) <= 5 ? 'c-up' : (e.limitDownCount || 0) <= 20 ? 'c-neutral' : 'c-down',
        diff: avg5.limitDown != null ? +((e.limitDownCount || 0) - avg5.limitDown).toFixed(0) : null
      }, {
        key: 'turnover',
        label: '成交额',
        value: this.fmtYi(this.latestDay && this.latestDay.turnover && this.latestDay.turnover.value),
        unit: '亿',
        cls: 'c-neutral',
        diff: null
      }];
    },
    emotionScore() {
      const e = this.latestEmotionMetrics;
      if (!e) return 50;
      const pr = e.promotionRates || {};
      const high = pr.high || 0;
      const p12 = pr['1to2'] || 0;
      const broken = (1 - (e.brokenRatio || 0)) * 100;
      const ld = Math.max(0, 100 - (e.limitDownCount || 0) * 2);
      return Math.round(Math.min(100, Math.max(0, high * 0.3 + p12 * 0.25 + broken * 0.25 + ld * 0.2)));
    },
    // 阶段判定：结合趋势方向，同区间上升=回暖/加速，下降=退潮/降温
    stageLabel() {
      const s = this.emotionScore;
      const cooling = this.emotionTrend < 0;
      if (s >= 70) return '高潮';
      if (s >= 50) return cooling ? '降温' : '加速';
      if (s >= 30) return cooling ? '退潮' : '回暖';
      return '冰点';
    },
    stageClass() {
      const s = this.emotionScore;
      const cooling = this.emotionTrend < 0;
      if (s >= 70) return 'stage-hot';
      if (s >= 50) return cooling ? 'stage-cool' : 'stage-warm';
      if (s >= 30) return cooling ? 'stage-fade' : 'stage-recover';
      return 'stage-cold';
    },
    gaugeColor() {
      const s = this.emotionScore;
      const cooling = this.emotionTrend < 0;
      if (s >= 70) return '#dc2626';
      if (s >= 50) return cooling ? '#b45309' : '#d97706';
      if (s >= 30) return cooling ? '#059669' : '#2563eb';
      return '#64748b';
    },
    gaugeDash() {
      const total = Math.PI * 80;
      const filled = total * (this.emotionScore / 100);
      return filled + ' ' + (total - filled);
    },
    needleX() {
      const angle = Math.PI * (1 - this.emotionScore / 100);
      return 100 + 70 * Math.cos(angle);
    },
    needleY() {
      const angle = Math.PI * (1 - this.emotionScore / 100);
      return 110 - 70 * Math.sin(angle);
    },
    emotionTrend() {
      const yd = this.yesterdayDay;
      if (!yd || !yd.emotionMetrics) return 0;
      const prev = yd.emotionMetrics;
      const ppr = prev.promotionRates || {};
      const prevScore = Math.round((ppr.high || 0) * 0.3 + (ppr['1to2'] || 0) * 0.25 + (1 - (prev.brokenRatio || 0)) * 100 * 0.25 + Math.max(0, 100 - (prev.limitDownCount || 0) * 2) * 0.2);
      return this.emotionScore - prevScore;
    },
    currentLeader() {
      // 优先从实时涨停池取今日最高连板股（盘中实时龙头）
      if (this.limitUpStocks.length) {
        let best = null;
        let bestDays = 0;
        this.limitUpStocks.forEach(s => {
          const days = s.limit_up_days || 1;
          if (days > bestDays || days === bestDays && best && (s.buy_lock_volume_ratio || 0) > (best.buy_lock_volume_ratio || 0)) {
            best = s;
            bestDays = days;
          }
        });
        if (best) {
          return {
            name: best.stock_chi_name,
            code: best.symbol,
            board: bestDays,
            theme: best.surge_reason && best.surge_reason.related_plates && best.surge_reason.related_plates[0] ? best.surge_reason.related_plates[0].plate_name : '',
            realtime: true
          };
        }
      }
      // 回退到周期数据
      const d = this.latestDay;
      if (!d || !d.ladder) return null;
      const levels = Object.keys(d.ladder).map(Number).sort((a, b) => b - a);
      if (!levels.length) return null;
      const stocks = d.ladder[levels[0]];
      if (!stocks || !stocks.length) return null;
      const s = stocks[0];
      return {
        name: s.name,
        code: s.code,
        board: levels[0],
        theme: s.themes && s.themes[0] || '',
        realtime: false
      };
    },
    leaderPrice() {
      if (!this.currentLeader) return null;
      return this.priceMap[this.toExCode(this.currentLeader.code)] || null;
    },
    leaderRealtime() {
      if (!this.currentLeader || !this.limitUpStocks.length) return null;
      const code = String(this.currentLeader.code).replace(/[^0-9]/g, '');
      const found = this.limitUpStocks.find(s => String(s.symbol || '').replace(/[^0-9]/g, '') === code);
      if (!found) return null;
      return {
        lockTime: this.fmtLockTime(found.first_limit_up),
        lockRatio: found.buy_lock_volume_ratio != null ? +(found.buy_lock_volume_ratio * 100).toFixed(1) : null,
        breakTimes: found.break_limit_up_times || 0
      };
    },
    leaderTrail() {
      const trail = [];
      let prevName = null;
      let prevBoard = null;
      const todayStr = this.formatDate(new Date());
      const hasRealtime = !!(this.currentLeader && this.currentLeader.realtime);
      for (let i = 0; i < this.rawCycle.length; i++) {
        const d = this.rawCycle[i];
        if (!d.ladder) continue;
        // 有实时数据时跳过周期API的今日行，避免重复/滞后
        if (hasRealtime && d.date === todayStr) continue;
        const levels = Object.keys(d.ladder).map(Number).sort((a, b) => b - a);
        if (!levels.length) continue;
        const stocks = d.ladder[levels[0]];
        if (!stocks || !stocks.length) continue;
        const name = stocks[0].name;
        const switched = prevName !== null && prevName !== name;
        let switchType = '';
        if (switched && prevBoard !== null) {
          if (levels[0] >= prevBoard) switchType = 'strong';else if (levels[0] <= prevBoard - 3) switchType = 'crash';else switchType = 'weak';
        }
        trail.push({
          date: d.date,
          board: levels[0],
          name: name.length > 4 ? name.slice(0, 4) : name,
          switched,
          switchType
        });
        prevName = name;
        prevBoard = levels[0];
      }
      // 追加今日实时龙头行（盘中）
      if (hasRealtime && (!trail.length || trail[trail.length - 1].date !== todayStr)) {
        const rtName = this.currentLeader.name;
        const switched = prevName !== null && prevName !== rtName;
        let switchType = '';
        if (switched && prevBoard !== null) {
          if (this.currentLeader.board >= prevBoard) switchType = 'strong';else if (this.currentLeader.board <= prevBoard - 3) switchType = 'crash';else switchType = 'weak';
        }
        trail.push({
          date: todayStr,
          board: this.currentLeader.board,
          name: rtName.length > 4 ? rtName.slice(0, 4) : rtName,
          switched,
          switchType,
          realtime: true
        });
      }
      return trail.slice(-10);
    },
    // 昨日涨停今日表现：汇总
    yesterdayPerformance() {
      const arr = this.yesterdayLimitUpStocks;
      if (!arr.length) return null;
      let upCount = 0,
        sumPct = 0,
        continuedCount = 0,
        nukedCount = 0;
      arr.forEach(s => {
        const pct = (s.change_percent || 0) * 100;
        sumPct += pct;
        if (pct > 0) upCount++;
        if (pct >= 9.8) continuedCount++;
        if (pct <= -5) nukedCount++;
      });
      return {
        total: arr.length,
        upCount,
        upRatio: +(upCount / arr.length * 100).toFixed(0),
        avgPremium: +(sumPct / arr.length).toFixed(2),
        continuedCount,
        nukedCount
      };
    },
    // 昨日涨停今日表现：按涨幅排序的名单
    yesterdaySorted() {
      const arr = this.yesterdayLimitUpStocks;
      if (!arr.length) return [];
      return arr.slice().sort((a, b) => (b.change_percent || 0) - (a.change_percent || 0)).slice(0, 12).map(s => {
        const pct = +((s.change_percent || 0) * 100).toFixed(2);
        const ydDays = s.yesterday_limit_up_days || 1;
        const continued = pct >= 9.8;
        const theme = s.surge_reason && s.surge_reason.related_plates && s.surge_reason.related_plates[0] ? s.surge_reason.related_plates[0].plate_name : '';
        return {
          name: s.stock_chi_name,
          pct,
          level: continued ? ydDays + '→' + (ydDays + 1) : '',
          theme,
          nuked: pct <= -5,
          continued
        };
      });
    },
    todayBoardLevels() {
      // 优先从实时涨停池构建（盘中实时），回退到周期数据
      if (this.limitUpStocks.length) {
        const groups = {};
        this.limitUpStocks.forEach(s => {
          const days = s.limit_up_days || 1;
          if (!groups[days]) groups[days] = [];
          groups[days].push({
            name: s.stock_chi_name,
            code: s.symbol,
            theme: s.surge_reason && s.surge_reason.related_plates && s.surge_reason.related_plates[0] ? s.surge_reason.related_plates[0].plate_name : '',
            lockTime: this.fmtLockTime(s.first_limit_up),
            lockRatio: s.buy_lock_volume_ratio != null ? +(s.buy_lock_volume_ratio * 100).toFixed(1) : null,
            breakTimes: s.break_limit_up_times || 0,
            timeline: this.fmtTimeline(s.limit_timeline && s.limit_timeline.items)
          });
        });
        return Object.keys(groups).map(Number).sort((a, b) => b - a).map(level => ({
          num: level,
          stocks: groups[level]
        }));
      }
      const d = this.latestDay;
      if (!d || !d.ladder) return [];
      return Object.keys(d.ladder).map(Number).sort((a, b) => b - a).map(level => ({
        num: level,
        stocks: (d.ladder[level] || []).map(s => ({
          name: s.name,
          code: s.code,
          theme: s.themes && s.themes[0] || ''
        }))
      }));
    },
    sectorRows() {
      const rows = [];
      const todayStr = this.formatDate(new Date());
      // 今日实时行：从涨停池题材聚合
      if (this.limitUpStocks.length) {
        const themeMap = {};
        this.limitUpStocks.forEach(s => {
          const t = s.surge_reason && s.surge_reason.related_plates && s.surge_reason.related_plates[0] ? s.surge_reason.related_plates[0].plate_name : '其他';
          const lv = s.limit_up_days || 1;
          if (!themeMap[t]) themeMap[t] = {
            name: t,
            maxBoard: lv,
            stockCount: 0,
            leader: '',
            leaderBoard: 0
          };
          if (lv > themeMap[t].maxBoard) themeMap[t].maxBoard = lv;
          if (lv > themeMap[t].leaderBoard) {
            themeMap[t].leader = s.stock_chi_name;
            themeMap[t].leaderBoard = lv;
          }
          themeMap[t].stockCount++;
        });
        const hots = Object.values(themeMap).sort((a, b) => b.stockCount - a.stockCount).slice(0, 6);
        hots.forEach(h => {
          h.streak = this.calcRealtimeStreak(h.name);
        });
        rows.push({
          date: todayStr,
          hots
        });
      }
      for (let i = 0; i < Math.min(this.cycleData.length, 10); i++) {
        const d = this.cycleData[i];
        if (!d.ladder) continue;
        if (d.date === todayStr && this.limitUpStocks.length) continue; // 有实时数据时跳过周期API的今日行
        const themeMap = {};
        Object.keys(d.ladder).forEach(level => {
          const lv = parseInt(level, 10);
          const arr = d.ladder[level] || [];
          arr.forEach(s => {
            const t = s.themes && s.themes[0] || '其他';
            if (!themeMap[t]) themeMap[t] = {
              name: t,
              maxBoard: lv,
              stockCount: 0,
              leader: '',
              leaderBoard: 0
            };
            if (lv > themeMap[t].maxBoard) themeMap[t].maxBoard = lv;
            if (lv > themeMap[t].leaderBoard) {
              themeMap[t].leader = s.name;
              themeMap[t].leaderBoard = lv;
            }
            themeMap[t].stockCount++;
          });
        });
        const hots = Object.values(themeMap).sort((a, b) => b.stockCount - a.stockCount).slice(0, 6);
        hots.forEach(h => {
          h.streak = this.calcStreak(h.name, i);
        });
        rows.push({
          date: d.date,
          hots
        });
      }
      return rows.slice(0, 10);
    },
    limitUpCount() {
      const fromPool = this.limitUpStocks.length;
      if (fromPool) return fromPool;
      return this.todayBoardLevels.reduce((s, l) => s + l.stocks.length, 0);
    },
    limitDownCount() {
      if (this.limitDownStocks.length) return this.limitDownStocks.length;
      const d = this.latestDay;
      return d && d.emotionMetrics && d.emotionMetrics.limitDownCount || 0;
    },
    brokenCount() {
      if (this.brokenStocks.length) return this.brokenStocks.length;
      const d = this.latestDay;
      return d && d.emotionMetrics && d.emotionMetrics.brokenCount || 0;
    },
    brokenRatio() {
      if (this.limitUpStocks.length || this.brokenStocks.length) {
        const total = this.limitUpStocks.length + this.brokenStocks.length;
        return total ? +(this.brokenStocks.length / total * 100).toFixed(1) : 0;
      }
      const d = this.latestDay;
      return d && d.emotionMetrics ? +(d.emotionMetrics.brokenRatio * 100).toFixed(1) : 0;
    },
    brokenRatioDiff() {
      const avg5 = this.avgMetrics(5);
      if (avg5.brokenRatio == null) return null;
      return +(this.brokenRatio - avg5.brokenRatio).toFixed(1);
    },
    brokenHint() {
      const r = this.brokenRatio;
      const diff = this.brokenRatioDiff;
      let base;
      if (r >= 40) base = '炸板率极高，打板亏钱效应强';else if (r >= 25) base = '炸板率偏高，注意封板质量';else if (r >= 15) base = '炸板率正常';else base = '炸板率低，封板意愿强';
      if (diff != null && diff >= 8) return base + '，较5日均骤升' + diff + '%，封板质量恶化';
      if (diff != null && diff <= -8) return base + '，较5日均回落' + Math.abs(diff) + '%，封板质量改善';
      return base;
    },
    limitDownHint() {
      const n = this.limitDownCount;
      const avg5 = this.avgMetrics(5);
      let base;
      if (n >= 30) base = '跌停潮出现，亏钱效应极强，严禁接力';else if (n >= 15) base = '跌停较多，空头力量强，注意风险';else if (n >= 5) base = '跌停正常，关注是否有核按钮扩散';else base = '跌停稀少，空头力量弱，环境偏暖';
      if (avg5.limitDown != null && n >= avg5.limitDown * 2 && n - avg5.limitDown >= 3) {
        return base + '，环比骤增（5日均' + avg5.limitDown + '只），退潮先行信号';
      }
      if (avg5.limitDown != null && avg5.limitDown >= 5 && n <= avg5.limitDown / 2) {
        return base + '，环比骤降（5日均' + avg5.limitDown + '只），空头力量消退';
      }
      return base;
    },
    turnoverText() {
      const d = this.latestDay;
      if (!d || !d.turnover || !d.turnover.value) return '—';
      return this.fmtYi(d.turnover.value) + '亿';
    },
    isMarketOpen() {
      const now = new Date();
      const day = now.getDay();
      if (day === 0 || day === 6) return false;
      const h = now.getHours();
      const m = now.getMinutes();
      const t = h * 60 + m;
      return t >= 570 && t <= 690 || t >= 780 && t <= 900; // 9:30-11:30 / 13:00-15:00
    },
    countdownText() {
      if (!this.isMarketOpen) return '休市中，数据暂停刷新';
      return this.countdown + 's 后自动刷新';
    },
    // A. 攻守建议：基于得分+阶段+趋势输出仓位/打法
    actionAdvice() {
      const s = this.emotionScore;
      const trend = this.emotionTrend;
      const yp = this.yesterdayPerformance;
      const cooling = trend < 0;
      let position, positionCls, tactic;
      if (s >= 70) {
        position = '满仓';
        positionCls = 'c-up';
        tactic = '追涨格局，聚焦3板+空间板，警惕盛极而衰';
      } else if (s >= 50) {
        if (cooling) {
          position = '半仓';
          positionCls = 'c-warn';
          tactic = '降温信号，高位股逐步兑现，只做确定性2板';
        } else {
          position = '半仓';
          positionCls = 'c-up';
          tactic = '做2板确认接力，最佳操作窗口';
        }
      } else if (s >= 30) {
        if (cooling) {
          position = '轻仓';
          positionCls = 'c-down';
          tactic = '退潮迹象，减仓防守，不接力不抄底';
        } else {
          position = '轻仓';
          positionCls = 'c-neutral';
          tactic = '1板试错为主，冰点后修复期控制节奏';
        }
      } else {
        position = '空仓';
        positionCls = 'c-down';
        tactic = '观望为主，不接力不抄底，等拐点信号';
      }
      let riskTag = '';
      if (trend <= -10) riskTag = '退潮预警';else if (yp && yp.nukedCount > 0 && yp.nukedCount >= yp.continuedCount) riskTag = '核按钮横行';
      return {
        position,
        positionCls,
        tactic,
        riskTag
      };
    },
    // B. 炸板股实时名单：按炸前连板数排序取前10
    brokenList() {
      if (!this.brokenStocks.length) return [];
      return this.brokenStocks.slice().sort((a, b) => (b.limit_up_days || 0) - (a.limit_up_days || 0)).slice(0, 10).map(s => ({
        name: s.stock_chi_name,
        pct: +((s.change_percent || 0) * 100).toFixed(2),
        days: s.limit_up_days || 0,
        breakTimes: s.break_limit_up_times || 0,
        lastBreak: this.fmtLockTime(s.last_break_limit_up),
        theme: s.surge_reason && s.surge_reason.related_plates && s.surge_reason.related_plates[0] ? s.surge_reason.related_plates[0].plate_name : '',
        timeline: this.fmtTimeline(s.limit_timeline && s.limit_timeline.items)
      }));
    },
    // C. 跌停股带板块标签
    limitDownWithTheme() {
      if (!this.limitDownStocks.length) return [];
      return this.limitDownStocks.slice(0, 16).map(s => ({
        symbol: s.symbol,
        name: s.stock_chi_name,
        pct: +((s.change_percent || 0) * 100).toFixed(2),
        theme: s.surge_reason && s.surge_reason.related_plates && s.surge_reason.related_plates[0] ? s.surge_reason.related_plates[0].plate_name : ''
      }));
    },
    // C. 崩塌板块：同板块≥2只跌停
    limitDownCollapseThemes() {
      const counts = {};
      this.limitDownWithTheme.forEach(s => {
        if (s.theme) counts[s.theme] = (counts[s.theme] || 0) + 1;
      });
      return Object.keys(counts).filter(t => counts[t] >= 2);
    },
    // D. 情绪转折信号：连续趋势检测
    emotionSignal() {
      const scores = [];
      const todayStr = this.formatDate(new Date());
      for (let i = Math.max(0, this.rawCycle.length - 5); i < this.rawCycle.length; i++) {
        const d = this.rawCycle[i];
        if (d.date === todayStr && this.realtimeEmotionMetrics) {
          scores.push(this.emotionScore);
        } else if (d.emotionMetrics) {
          scores.push(this.dailyScore(d));
        }
      }
      if (scores.length < 3) return null;
      let upStreak = 0,
        downStreak = 0;
      for (let i = scores.length - 1; i > 0; i--) {
        if (scores[i] > scores[i - 1]) {
          if (downStreak) break;
          upStreak++;
        } else if (scores[i] < scores[i - 1]) {
          if (upStreak) break;
          downStreak++;
        } else break;
      }
      const lastDiff = scores.length >= 2 ? scores[scores.length - 1] - scores[scores.length - 2] : 0;
      if (lastDiff <= -10) return {
        type: 'crash',
        label: '退潮预警',
        cls: 'sig-down',
        desc: '骤降' + lastDiff + '分，果断减仓'
      };
      if (upStreak >= 3) return {
        type: 'recover',
        label: '回暖确认',
        cls: 'sig-up',
        desc: '连升' + upStreak + '日，可逐步进场'
      };
      if (downStreak >= 3) return {
        type: 'fade',
        label: '持续退潮',
        cls: 'sig-down',
        desc: '连降' + downStreak + '日，严控仓位'
      };
      if (lastDiff >= 10) return {
        type: 'surge',
        label: '情绪反转',
        cls: 'sig-up',
        desc: '骤升+' + lastDiff + '分，冰点反转信号'
      };
      return null;
    },
    // F. 天梯健康度：金字塔/倒挂/断层
    ladderHealth() {
      const levels = this.todayBoardLevels;
      if (levels.length < 2) return null;
      const boardNums = levels.map(l => l.num);
      const counts = levels.map(l => l.stocks.length);
      const maxB = Math.max(...boardNums);
      const minB = Math.min(...boardNums);
      const missing = [];
      for (let b = minB + 1; b < maxB; b++) {
        if (!boardNums.includes(b)) missing.push(b);
      }
      let inverted = false;
      for (let i = 0; i < levels.length && !inverted; i++) {
        for (let j = i + 1; j < levels.length; j++) {
          if (counts[i] > counts[j]) {
            inverted = true;
            break;
          }
        }
      }
      if (inverted) return {
        type: 'inverted',
        label: '倒挂',
        cls: 'lh-bad',
        desc: '高位多于低位，结构异常，警惕退潮'
      };
      if (missing.length && maxB - minB >= 3) {
        const midGap = missing.some(b => b >= 2 && b <= 3);
        return midGap ? {
          type: 'gap',
          label: '中位断层',
          cls: 'lh-bad',
          desc: '缺' + missing.join('/') + '板，中位卡死退潮前兆'
        } : {
          type: 'gap',
          label: '高位断层',
          cls: 'lh-warn',
          desc: '缺' + missing.join('/') + '板，龙头独走结构'
        };
      }
      return {
        type: 'healthy',
        label: '金字塔',
        cls: 'lh-ok',
        desc: '底宽顶窄，结构健康'
      };
    },
    // ═══ 游资实战信号（事件驱动，非指标翻译）═══
    // 1. 龙头生死：昨日最高板龙头今日状态（晋级/炸板/跌停/断板）
    leaderStatus() {
      if (!this.currentLeader || !this.currentLeader.realtime) return null;
      const todayStr = this.formatDate(new Date());
      let yest = null;
      for (let i = this.rawCycle.length - 1; i >= 0; i--) {
        const d = this.rawCycle[i];
        if (d.date === todayStr || !d.ladder) continue;
        const levels = Object.keys(d.ladder).map(Number).sort((a, b) => b - a);
        if (levels.length && d.ladder[levels[0]] && d.ladder[levels[0]].length) {
          const s0 = d.ladder[levels[0]][0];
          yest = {
            name: s0.name,
            code: String(s0.code || '').replace(/[^0-9]/g, ''),
            board: levels[0]
          };
          break;
        }
      }
      if (!yest) return null;
      const norm = c => String(c || '').replace(/[^0-9]/g, '');
      const switched = this.currentLeader.name !== yest.name;
      // 涨停池：还在板上涨停 → 晋级
      const inUp = this.limitUpStocks.find(s => norm(s.symbol) === yest.code);
      if (inUp && (inUp.limit_up_days || 1) >= yest.board + 1) {
        return {
          label: '龙头晋级',
          desc: yest.name + ' ' + (yest.board + 1) + '板，周期延续',
          cls: 'sig-up',
          pri: 1
        };
      }
      // 炸板池
      const inBroken = this.brokenStocks.find(s => norm(s.symbol) === yest.code);
      if (inBroken) {
        return {
          label: switched ? '龙头炸板·换龙' : '龙头炸板',
          desc: yest.name + '(' + yest.board + '板)炸板' + (switched ? '，' + this.currentLeader.name + '接棒' : '，周期拐点'),
          cls: 'sig-down',
          pri: 1
        };
      }
      // 跌停池
      const inDown = this.limitDownStocks.find(s => norm(s.symbol) === yest.code);
      if (inDown) {
        return {
          label: '龙头跌停',
          desc: yest.name + '(' + yest.board + '板)跌停，周期终结',
          cls: 'sig-down',
          pri: 1
        };
      }
      // 昨日涨停表现：断板（涨但没涨停）
      const inYp = this.yesterdayLimitUpStocks.find(s => norm(s.symbol) === yest.code);
      if (inYp) {
        const pct = +((inYp.change_percent || 0) * 100).toFixed(2);
        if (pct < 9.8) {
          return {
            label: switched ? '龙头断板·换龙' : '龙头断板',
            desc: yest.name + ' 涨' + pct + '%断板' + (switched ? '，' + this.currentLeader.name + this.currentLeader.board + '板接棒' : '，高位兑现'),
            cls: 'sig-warn',
            pri: 2
          };
        }
      }
      return null;
    },
    // 2. 核按钮：3板+炸板股（高位炸板才是核按钮，1板炸板不算）
    nukeAlert() {
      const nuked = this.brokenStocks.filter(s => (s.limit_up_days || 0) >= 3);
      if (!nuked.length) return null;
      const names = nuked.slice().sort((a, b) => (b.limit_up_days || 0) - (a.limit_up_days || 0)).slice(0, 3).map(s => s.stock_chi_name + '(' + (s.limit_up_days || 0) + '板)').join('、');
      return {
        label: '核按钮',
        desc: names + ' 高位炸板' + (nuked.length > 3 ? '等' + nuked.length + '只' : ''),
        cls: 'sig-down',
        pri: 1
      };
    },
    // 3. 打板溢价：昨日打板今日有没有钱赚
    premiumSignal() {
      const yp = this.yesterdayPerformance;
      if (!yp) return null;
      if (yp.nukedCount >= 3 && yp.nukedCount >= yp.continuedCount) {
        return {
          label: '核按钮横行',
          desc: '昨涨停今被核' + yp.nukedCount + '只 ≥ 晋级' + yp.continuedCount + '只，只卖不买',
          cls: 'sig-down',
          pri: 1
        };
      }
      if (yp.avgPremium < 0) {
        return {
          label: '打板无溢价',
          desc: '昨涨停今均' + yp.avgPremium + '%，接力亏钱',
          cls: 'sig-down',
          pri: 2
        };
      }
      if (yp.avgPremium >= 3 && yp.upRatio >= 60) {
        return {
          label: '溢价强',
          desc: '昨涨停今均+' + yp.avgPremium + '% 红盘比' + yp.upRatio + '%，接力可做',
          cls: 'sig-up',
          pri: 3
        };
      }
      return null;
    },
    // 4. 回封速度：炸过又封回的股，回封越快承接越强
    reflowSignal() {
      const reflowed = this.limitUpStocks.filter(s => (s.break_limit_up_times || 0) > 0);
      if (!reflowed.length) return null;
      let fastest = null,
        fastName = '';
      reflowed.forEach(s => {
        const m = this.calcReflowMinutes(s.limit_timeline && s.limit_timeline.items);
        if (m !== null && (fastest === null || m < fastest)) {
          fastest = m;
          fastName = s.stock_chi_name;
        }
      });
      if (fastest === null) return null;
      const mins = Math.round(fastest);
      if (mins <= 5) return {
        label: '承接强',
        desc: fastName + ' 炸后' + mins + '分钟回封，分歧转一致',
        cls: 'sig-up',
        pri: 3
      };
      if (mins >= 30) return {
        label: '分歧大',
        desc: fastName + ' 炸后' + mins + '分钟才回封，筹码松动',
        cls: 'sig-warn',
        pri: 2
      };
      return null;
    },
    // 汇总：按实战优先级排序（龙头生死 > 核按钮 > 溢价 > 回封）
    battleSignals() {
      return [this.leaderStatus, this.nukeAlert, this.premiumSignal, this.reflowSignal].filter(Boolean).sort((a, b) => (a.pri || 9) - (b.pri || 9));
    }
  },
  mounted() {
    this.loadData();
    this.startAutoRefresh();
    document.addEventListener('click', this.closeTopTip);
  },
  beforeUnmount() {
    this.stopAutoRefresh();
    document.removeEventListener('click', this.closeTopTip);
  },
  methods: {
    toExCode(raw) {
      const c = String(raw || '').replace(/[^0-9]/g, '');
      if (!c) return '';
      if (c[0] === '6') return c + '.SH';
      if (c[0] === '8' || c[0] === '4') return c + '.BJ';
      return c + '.SZ';
    },
    fmtYi(val) {
      const n = parseInt(val, 10) || 0;
      if (!n) return '—';
      return (n / 1e8).toFixed(0);
    },
    fmtLockTime(ts) {
      if (!ts) return '';
      const d = new Date(ts * 1000);
      return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    },
    // 解析 limit_timeline.items → { dots: [{t,s}], text: "09:35封→09:37炸→..." }
    fmtTimeline(items) {
      if (!items || !items.length) return null;
      let dots = items.map(it => ({
        t: this.fmtLockTime(it.timestamp),
        s: it.status
      }));
      if (dots.length > 6) dots = [...dots.slice(0, 2), {
        t: '…',
        s: 0
      }, ...dots.slice(-3)];
      const text = items.map(it => this.fmtLockTime(it.timestamp) + (it.status === 1 ? '封' : '炸')).join(' → ');
      return {
        dots,
        text
      };
    },
    showMtTip(e, text) {
      const r = e.target.getBoundingClientRect();
      this.mtFloat = {
        show: true,
        x: r.left + r.width / 2,
        y: r.top - 6,
        text
      };
    },
    hideMtTip() {
      this.mtFloat.show = false;
    },
    // 回封速度：timeline 里炸(2)→封(1)的最短时间差（分钟）
    calcReflowMinutes(items) {
      if (!items || items.length < 2) return null;
      let fastest = null;
      for (let i = 1; i < items.length; i++) {
        if (items[i - 1].status === 2 && items[i].status === 1) {
          const diff = (new Date(items[i].timestamp).getTime() - new Date(items[i - 1].timestamp).getTime()) / 60000;
          if (diff >= 0 && (fastest === null || diff < fastest)) fastest = diff;
        }
      }
      return fastest;
    },
    avgMetrics(n) {
      const days = this.rawCycle.slice(-n).filter(d => d.emotionMetrics);
      if (!days.length) return {};
      const sum = {
        highPromo: 0,
        p12: 0,
        brokenRatio: 0,
        limitDown: 0
      };
      days.forEach(d => {
        const e = d.emotionMetrics;
        const pr = e.promotionRates || {};
        sum.highPromo += pr.high || 0;
        sum.p12 += pr['1to2'] || 0;
        sum.brokenRatio += (e.brokenRatio || 0) * 100;
        sum.limitDown += e.limitDownCount || 0;
      });
      const len = days.length;
      return {
        highPromo: +(sum.highPromo / len).toFixed(1),
        p12: +(sum.p12 / len).toFixed(1),
        brokenRatio: +(sum.brokenRatio / len).toFixed(1),
        limitDown: +(sum.limitDown / len).toFixed(0)
      };
    },
    // D. 单日情绪得分（历史日，用于趋势序列）
    dailyScore(d) {
      if (!d || !d.emotionMetrics) return null;
      const pr = d.emotionMetrics.promotionRates || {};
      return Math.round(Math.min(100, Math.max(0, (pr.high || 0) * 0.3 + (pr['1to2'] || 0) * 0.25 + (1 - (d.emotionMetrics.brokenRatio || 0)) * 100 * 0.25 + Math.max(0, 100 - (d.emotionMetrics.limitDownCount || 0) * 2) * 0.2)));
    },
    calcStreak(name, fromIndex) {
      let streak = 0;
      for (let i = fromIndex; i < this.cycleData.length; i++) {
        const d = this.cycleData[i];
        if (!d.ladder) break;
        let found = false;
        Object.keys(d.ladder).forEach(level => {
          const arr = d.ladder[level] || [];
          arr.forEach(s => {
            if ((s.themes && s.themes[0] || '其他') === name) found = true;
          });
        });
        if (found) streak++;else break;
      }
      return streak;
    },
    calcRealtimeStreak(name) {
      let streak = 1; // 今日来自涨停池
      const todayStr = this.formatDate(new Date());
      for (let i = 0; i < this.cycleData.length; i++) {
        const d = this.cycleData[i];
        if (d.date === todayStr) continue; // 跳过周期API中的今日
        if (!d.ladder) break;
        let found = false;
        Object.keys(d.ladder).forEach(level => {
          const arr = d.ladder[level] || [];
          arr.forEach(s => {
            if ((s.themes && s.themes[0] || '其他') === name) found = true;
          });
        });
        if (found) streak++;else break;
      }
      return streak;
    },
    lifecycleLabel(streak) {
      if (streak >= 4) return '衰退预警';
      if (streak === 3) return '加速';
      if (streak === 2) return '确认';
      if (streak === 1) return '启动';
      return '';
    },
    lifecycleClass(streak) {
      if (streak >= 4) return 'lc-red';
      if (streak === 3) return 'lc-orange';
      if (streak === 2) return 'lc-blue';
      return 'lc-gray';
    },
    formatDate(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return y + '-' + m + '-' + day;
    },
    async loadData() {
      this.errorMsg = '';
      this.cycleLoaded = false;
      // 三个数据源并行请求，各自独立更新，不阻塞页面渲染
      this.loadCycleData().then(() => {
        this.cycleLoaded = true;
        this.markUpdateTime();
      }).catch(e => {
        console.error('[Youzi] loadCycleData error:', e);
        this.errorMsg = '周期数据加载失败，请点击右上角刷新重试';
        this.cycleLoaded = true;
      });
      this.loadSnapshot().then(() => this.markUpdateTime()).catch(() => {});
      this.fetchLimitPools().then(() => this.markUpdateTime()).catch(() => {});
    },
    async loadCycleData() {
      const end = new Date();
      const start = new Date();
      start.setDate(end.getDate() - 30);
      const startDate = this.formatDate(start);
      const endDate = this.formatDate(end);
      const res = await fetch('/server-api/quicktiny/ladder/cycle-analysis?startDate=' + startDate + '&endDate=' + endDate).then(r => r.json());
      const cycleArr = res && res.data ? res.data : [];
      this.rawCycle = cycleArr;
      this.cycleData = cycleArr.slice().reverse().map(d => this.mapCycleDay(d));
    },
    async loadSnapshot() {
      const res = await fetch('/server-api/dang-quote/quotes/v2/stock-latest/snapshot').then(r => r.json()).catch(() => null);
      if (res && res.data && res.data.items) {
        const map = {};
        res.data.items.forEach(it => {
          if (it && it.code) map[it.code] = {
            price: it.price,
            change: it.change,
            changePct: it.changePct,
            name: it.name
          };
        });
        this.priceMap = map;
      }
    },
    mapCycleDay(day) {
      return {
        date: day.date,
        week: day.weekday,
        ladder: day.ladder || {},
        emotionMetrics: day.emotionMetrics || {},
        turnover: day.turnover || {},
        index: day.index || {}
      };
    },
    async fetchLimitPools() {
      try {
        const [upRes, downRes, brokenRes, ydRes] = await Promise.all([fetch('https://flash-api.xuangubao.com.cn/api/pool/detail?pool_name=limit_up').then(r => r.json()).catch(() => null), fetch('https://flash-api.xuangubao.com.cn/api/pool/detail?pool_name=limit_down').then(r => r.json()).catch(() => null), fetch('https://flash-api.xuangubao.com.cn/api/pool/detail?pool_name=limit_up_broken').then(r => r.json()).catch(() => null), fetch('https://flash-api.xuangubao.com.cn/api/pool/detail?pool_name=yesterday_limit_up').then(r => r.json()).catch(() => null)]);
        if (upRes && upRes.data) this.limitUpStocks = upRes.data;
        if (downRes && downRes.data) this.limitDownStocks = downRes.data;
        if (brokenRes && brokenRes.data) this.brokenStocks = brokenRes.data;
        if (ydRes && ydRes.data) this.yesterdayLimitUpStocks = ydRes.data;
        this.poolsLoaded = true;
      } catch (e) {
        console.error('[Youzi] fetchLimitPools error:', e);
      }
    },
    startAutoRefresh() {
      // 实时快照 15s
      this.snapshotTimer = setInterval(() => {
        if (!this.isMarketOpen) return;
        this.loadSnapshot().then(() => this.markUpdateTime());
      }, 15000);
      // 涨停/跌停池 30s
      this.poolTimer = setInterval(() => {
        if (!this.isMarketOpen) return;
        this.fetchLimitPools().then(() => this.markUpdateTime());
      }, 30000);
      // 周期数据 5min
      this.cycleTimer = setInterval(() => {
        if (!this.isMarketOpen) return;
        this.loadCycleData().then(() => this.markUpdateTime());
      }, 300000);
      // 倒计时 1s
      this.countdown = 15;
      this.countdownTimer = setInterval(() => {
        if (!this.isMarketOpen) return;
        this.countdown--;
        if (this.countdown <= 0) this.countdown = 15;
      }, 1000);
    },
    stopAutoRefresh() {
      if (this.snapshotTimer) {
        clearInterval(this.snapshotTimer);
        this.snapshotTimer = null;
      }
      if (this.poolTimer) {
        clearInterval(this.poolTimer);
        this.poolTimer = null;
      }
      if (this.cycleTimer) {
        clearInterval(this.cycleTimer);
        this.cycleTimer = null;
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    async manualRefresh() {
      if (this.refreshing) return;
      this.refreshing = true;
      this.cycleLoaded = false;
      try {
        await Promise.race([Promise.all([this.loadSnapshot(), this.fetchLimitPools(), this.loadCycleData()]), new Promise(resolve => setTimeout(resolve, 8000))]);
        this.markUpdateTime();
        this.countdown = 15;
      } catch (e) {
        console.error('[Youzi] manualRefresh error:', e);
      } finally {
        this.refreshing = false;
        this.cycleLoaded = true;
      }
    },
    markUpdateTime() {
      const now = new Date();
      const h = String(now.getHours()).padStart(2, '0');
      const m = String(now.getMinutes()).padStart(2, '0');
      const s = String(now.getSeconds()).padStart(2, '0');
      this.lastUpdateTime = h + ':' + m + ':' + s;
    },
    closeTopTip() {
      this.topTipOpen = false;
    }
  }
};